const autopartsMessagesHeaderIntro = 'Hi! Welcome to Smart Auto Parts. '
  + 'Looking for automotive parts? Simply tell us what you need or upload a photo of your part, '
  + 'and we\'ll help you find the perfect match.';

export const TENANT_CONFIG = {
  'tenant-default': {
    'chat-title': 'Volcano Assistant',
    'messages-header-src': `https://images.contentstack.io/v3/assets/bltc8d4068062204b3a/bltcea6733523d796c4/64ad2b641003e1f1f1bb29a2/
photo_2022-08-15_13-39-19.jpg`,
    intent: 'welcome' as const,
    startNewSessionOnOpenWhenNoSession: true,
  },
  'tenant-autoparts': {
    'chat-title': 'Auto Parts Assistant',
    'messages-header-src': `https://images.contentstack.io/v3/assets/bltc8d4068062204b3a/bltb9bcd0c9156ad454/6849fe6337fce33107479295/
photo-1519752594763-2633d8d4ea29_tzxb5j_c_fill_w_1280_h_400.jpg`,
    'messages-header-intro': autopartsMessagesHeaderIntro,
    startNewSessionOnOpenWhenNoSession: false,
  },
};
